import { createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth"
import { auth, db } from '@/config/firebase';
import { collection, deleteDoc, doc, getDoc, getDocs, setDoc, updateDoc } from "firebase/firestore";
import { AdminModel } from "@/types/admin";

const AdminService = {

    /**
     * Loga Admin
     * @param email 
     * @param senha 
     * @returns {admin caso logado com sucesso, e o sucesso com um status de logado ou não}
     */
    logar: async(email: string, senha: string): Promise<{usuario?:any, sucesso:boolean}> => {
        return signInWithEmailAndPassword(auth, email, senha)
            .then(async (retorno) => { 
                
                //Verifica se o admin não foi excluido do banco
                const dados = await getDoc(doc(db, 'admin', retorno.user.uid));
                const data = dados.data() as AdminModel;
                
                if (dados.exists() && data.ativo)
                    return { sucesso: true , usuario: data }
                return { sucesso: false };
            
            })
            .catch(erro => { 
                console.log(erro)
                return { sucesso: false }
            });
    },

    /**
     * Função para recuperar senha
     * @param email 
     * @returns sucesso status booleano caso tenha conseguido solicitar nova senha
     */
    recuperarSenha: async (email: string): Promise<{sucesso: boolean}> => {
        return sendPasswordResetEmail(auth, email)
            .then((retorno) => { return { sucesso: true }})
            .catch(erro => { return { sucesso: false }});
    },

    /**
     * Retorna a lista de usuários do sistema
     * @returns 
     */
    buscarAdmins: async (): Promise<any[]> => {
        return getDocs(collection(db, 'admin'))
            .then(snapshots => {
                const retorno: any[] = [];
                snapshots.forEach(snap => {
                    retorno.push(snap.data())
                })
                return retorno;
            })
            .catch(erro => [])
    },

    /**
     * Retorna os dados de um usuário
     * @param id 
     * @returns 
     */
    buscar: async (id: string): Promise<any>  => {
        return getDoc(doc(db, 'admin', id))
            .then(retorno => { 
                return (retorno.exists() ? retorno.data() : null)
            })
            .catch(erro => null)
    },

    /**
     * Cadastra um novo usuário
     * @param admin 
     * @returns 
     */
    cadastrar: async (admin:any): Promise<{sucesso: boolean}> => {
        return createUserWithEmailAndPassword(auth, admin.email, admin.senha)
            .then(async retorno => {
                const adminDOC = doc(db, 'admin', retorno.user.uid)

                await setDoc(adminDOC, {
                    uid: retorno.user.uid,
                    nome: admin.nome,
                    email: admin.email,
                    ativo: admin.ativo == 'true'
                });
                return { sucesso: true };
            })
            .catch(erro => { 
                console.log(erro);
                return { sucesso: false} 
            });
    },

    /**
     * Edita um novo usuário
     * @param admin 
     * @returns 
     */
    editar: async (admin:any): Promise<{sucesso: boolean}> => {
        try {
            await updateDoc(doc(db, 'admin', admin.uid), {
                nome: admin.nome,
                ativo: admin.ativo == 'true'
            })
            return { sucesso: true };
        } catch (erro) {
            return { sucesso: false };
        }
    },
    
    /**
     * Excluir um admin
     * @param admin 
     * @returns 
     */
    excluir: async (admin:any): Promise<{sucesso: boolean}> => {
        return deleteDoc(doc(db, 'admin', admin.uid))
            .then(retorno => {
                return { sucesso: true }
            })
            .catch(erro => {
                return { sucesso: false }
            })
    }


}


export const useAdminService = () => AdminService;